<template>
	<div class="form-group is-phone-number">
		<label :for="getFieldId" v-text="placeholder"></label>
		<input class="form-control"
			   type="text"
			   :name="name"
			   :id="getFieldId"
               :readonly="readonly"
			   :required="required"
			   :maxlength="maxlength" @keyup="updateValue($event.target.value)" ref="input">
	</div>
</template>

<script>
    let Input = require('@/mixins/InputField')

    export default {

        mixins: [Input],

        data() {
            return {
                input: null,
                countries: [],
                currentCountry: 'us',
                code: '1',
                number: '',
            }
        },

        mounted() {
            this.initPhoneInput();
        },

        methods: {

            initPhoneInput() {
                this.$nextTick(() => {
                    this.countries = window.intlTelInputGlobals.getCountryData();
                    var selector = document.querySelector(`#${this.getFieldId}`);
                    this.input = window.intlTelInput(selector, {
                        formatOnDisplay: true,
                        separateDialCode: true,
                    });
                    this.setPhoneNumber();
                    selector.addEventListener("countrychange", () => {
                        this.code = this.input.getSelectedCountryData().dialCode;
                        this.updateValue(this.number);
                    });
                    $('#' + this.getFieldId).mask('(000) 000-0000');
                })
            },

            updateValue(value) {
                this.number = value;
                this.$emit('input', this.code + ' ' + this.number)
            },

            setPhoneNumber() {
                var value = this.value;
                if (this.value) {
                    var code = value.substr(0, value.indexOf(' '));
                    var country = this.countries.find(country => {
                        if (code == 1 && country.name != 'United States') {
                            return false;
                        }
                        return country.dialCode == code;
                    });
                    var iso2 = country ? country.iso2 : 'us';
                    this.input.setCountry(iso2);
                    this.currenCountry = iso2;
                    this.number = value.substring(value.indexOf(' ') + 1);
                    this.input.setNumber(this.number);
                }
            },
        },

        watch: {
            value(newValue) {
                this.setPhoneNumber();
            },
        }
    }
</script>
